// mobile phone image
import smartHeadPhone from "../images/smart_headPhone.webp";
import lokiaPhone from "../images/LokiaMobile.webp";
import simplePhone from "../images/simpleMobile.webp";
import iPhone7 from "../images/iphone7.webp";
import digitalHeadPhone from "../images/digitalHeadPhone.webp";
import HPC_Phone from "../images/HPC_Phone.webp";
import headPhoneLocal from "../images/headPhoneLocal.webp";
import headPhone from "../images/headPhone.webp";
import cap from "../images/cap.webp";
// mobile phone image

// mobile phone brand image
import apple from "../images/apple.webp";
import dell from "../images/dell.webp";
import xiaomi from "../images/xiaomi.webp";
import asus from "../images/asus.webp";
import sony from "../images/sony.webp";
import acer from "../images/acer.webp";
// mobile phone brand image

// mobile phone shop image
import shop1 from "../images/shop1.webp";
import shop2 from "../images/shop2.webp";
import shop3 from "../images/shop3.webp";
import shop4 from "../images/shop4.webp";
// mobile phone shop image

export const mobilePhone = [
  {
    id: 11,
    cardImg: smartHeadPhone,
    title: "maple earphones",
    prizeCurrent: "187.06",
    prizeClose: " $199.00",
    off: "6%",
    like: false,
  },
  {
    id: 12,
    cardImg: lokiaPhone,
    title: "lokia andriod one",
    prizeCurrent: "111.02",
    prizeClose: "$122.00",
    off: "9%",
    like: false,
  },
  {
    id: 13,
    cardImg: simplePhone,
    title: "xymphone lights",
    prizeCurrent: "229.50",
    prizeClose: "$255.00",
    off: "10%",
    like: false,
  },
  {
    id: 14,
    cardImg: iPhone7,
    title: "lphone 7",
    prizeCurrent: "103.55",
    prizeClose: "$109.00",
    off: "5%",
    like: false,
  },
  {
    id: 15,
    cardImg: digitalHeadPhone,
    title: "ceats wireless earphones",
    prizeCurrent: "171.95",
    prizeClose: "$181.00",
    off: "5%",
    like: false,
  },
  {
    id: 16,
    cardImg: HPC_Phone,
    title: "HPC 2018",
    prizeCurrent: "140.14",
    prizeClose: "$154.00",
    off: "9%",
    like: false,
  },
  {
    id: 17,
    cardImg: headPhoneLocal,
    title: "xeats bluetooth earphones",
    prizeCurrent: "134.68",
    prizeClose: "$148.00",
    off: "9%",
    like: false,
  },
  {
    id: 18,
    cardImg: headPhone,
    title: "sbs wireless earphones",
    prizeCurrent: "145.60",
    prizeClose: "$160.00",
    off: "9%",
    like: false,
  },
  {
    id: 19,
    cardImg: cap,
    title: "silver cap",
    prizeCurrent: "225.15",
    prizeClose: "$237.00",
    off: "9%",
    like: false,
  },
];

export const mobilePhoneBrand = [
  {
    img: apple,
    text: "Apple",
  },
  {
    img: dell,
    text: "Dell",
  },
  {
    img: xiaomi,
    text: "Xiaomi",
  },
  {
    img: asus,
    text: "Asus",
  },
  {
    img: sony,
    text: "Sony",
  },
  {
    img: acer,
    text: "Acer",
  },
];

export const mobilePhoneShop = [
  {
    img: shop1,
    text: "Keyboard Kiosk",
  },
  {
    img: shop2,
    text: "Anytime Buys",
  },
  {
    img: shop3,
    text: "Word Wide Wishes",
  },
  {
    img: shop4,
    text: "Cybershop",
  },
];
